/**
 * 粒子交互行为
 */
export var ParticleInteractionBehavior;
(function (ParticleInteractionBehavior) {
    /**
     * 无
     */
    ParticleInteractionBehavior[ParticleInteractionBehavior["none"] = 0] = "none";
    /**
     * 移出粒子
     */
    ParticleInteractionBehavior[ParticleInteractionBehavior["removeParticle"] = 1] = "removeParticle";
})(ParticleInteractionBehavior || (ParticleInteractionBehavior = {}));
